export const checkboxFilterMaxVisibleItems = 7
export const checkboxFilterCounterLimit = 9
